/** The dashboard's figures for the role in use (M31, ADR-0042). */
import { useQuery } from "@tanstack/react-query";

import { api, type Schemas, unwrap } from "./client";

export type Dashboard = Schemas["DashboardOut"];

export function useDashboard() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => unwrap(await api.GET("/api/v1/dashboard")),
    staleTime: 30_000,
  });
}
